import {
  HandlersWorkflowTypeWithSigning as DbWorkflowType,
  useDeleteApiWorkflowsTypesByWorkflowTypeMutation,
  useGetApiWorkflowsTypesQuery,
  usePatchApiWorkflowsTypesByWorkflowTypeMutation,
  usePostApiWorkflowsTypesMutation,
} from '../../../../app/athenaApiGen';
import AdminCatalogPanel from '../AdminCatalogPanel';

// WorkflowType uses the shared WorkflowCatalog request shape: `{ name, description }`.
const AdminWorkflowTypesPanel = () => (
  <AdminCatalogPanel<DbWorkflowType>
    tableName="Workflow Type"
    apiPath="/api/workflows/types"
    pkAccessor="workflowType"
    useList={() => useGetApiWorkflowsTypesQuery({ archived: true })}
    useCreate={usePostApiWorkflowsTypesMutation}
    useUpdate={usePatchApiWorkflowsTypesByWorkflowTypeMutation}
    useDelete={useDeleteApiWorkflowsTypesByWorkflowTypeMutation}
    buildCreateArg={(v) => ({
      handlersWorkflowCatalogRequest: {
        name: (v.workflowType as string) ?? '',
        description: v.description as string | undefined,
      },
    })}
    buildUpdateArg={(row, v) => ({
      workflowType: row.workflowType as string,
      handlersWorkflowCatalogUpdateRequest: {
        description: v.description as string | undefined,
      },
    })}
    buildDeleteArg={(row) => ({ workflowType: row.workflowType as string })}
    fields={[
      {
        name: 'workflowType',
        label: 'Workflow Type',
        type: 'text',
        required: true,
        immutableOnEdit: true,
      },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'archived', label: 'Archived', type: 'boolean' },
    ]}
    fkConflictMessage="Active Workflows or ProgramWorkflowType assignments still reference this type."
  />
);

export default AdminWorkflowTypesPanel;
